(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seulab-quick-buy-script"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('seulab-quick-buy')) {
    class SeulabQuickBuy extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-seulab-add]');
        this.cartDrawer = document.querySelector('drawer-cart');
        if (!this.form || !this.button) return;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const formData = new FormData(this.form);
        const payload = { items: [{}] };
        formData.forEach((value, key) => {
          payload.items[0][key] = value;
        });

        HELPER_UTIL.submitButtonState(this.button).loadingState();

        HELPER_UTIL.fetchData({
          method: 'POST',
          config: {
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json'
            }
          },
          url: `${window.Shopify.routes.root}cart/add.js?sections=${HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString()}`,
          data: JSON.stringify(payload),
          onsuccess: (data) => {
            if (this.cartDrawer) {
              window.currentActiveElement = this.button;
              HELPER_UTIL.dispatchCustomEvent(
                _EVENT_HELPER.triggerCartChange,
                this.button,
                { sections: data.sections }
              );
              HELPER_UTIL.submitButtonState(this.button).completeState();
            } else {
              window.location.href = `${window.Shopify.routes.root}cart`;
            }
          },
          onerror: (error) => {
            if (error?.json) {
              error.json().then((errorObj) => {
                HELPER_UTIL.dispatchCustomEvent(
                  _EVENT_HELPER.triggerToastMessage,
                  document,
                  {
                    toastType: 'common-errors',
                    messageType: 'error',
                    message: errorObj.description || 'Ürün sepete eklenemedi.'
                  }
                );
              });
            }
          },
          defaultCb: () => {
            setTimeout(() => {
              HELPER_UTIL.submitButtonState(this.button).resetState(800);
              HELPER_UTIL.submitButtonState(this.button).disableState(false);
            }, 800);
          }
        });
      }
    }

    window.customElements.define('seulab-quick-buy', SeulabQuickBuy);
  }
  } catch(e) { console.error(e); }
})();

})();
